import React from 'react';
import { connect } from 'react-redux';
import { logOut, registerRoutes } from '../../../func';
import Axios from 'axios';
import moment from 'moment';
import { Link } from 'react-router-dom';

class ErrorTab extends React.Component {
  constructor(props) {
    super(props);
    this.authData = JSON.parse(localStorage.getItem('auth_data'));
    this.state = this.initState();
  }

  initState = () => ({
    loading: false,
    errorList: null,
    contextMenu: {
      clientX: 0,
      clientY: 0,
      show: false,
      error: null,
    },
    showDetail: false,
  });

  componentDidMount = () => {
    this.networkCalls = registerRoutes(this.networkCalls, this.props.path);
    this.networkCalls.getReadRecentCustomerPortalErrors();
    this.initListeners();
  };

  componentWillUnmount = () => {
    this.removeListeners();
  };

  initListeners = () => {
    document.addEventListener('click', this.clickAwayListener);
  };

  removeListeners = () => {
    document.removeEventListener('click', this.clickAwayListener);
  };

  clickAwayListener = e => {
    if (
      this.state.contextMenu.show &&
      !document.querySelector('#context-menu').contains(e.target)
    )
      this.setState({
        contextMenu: {
          clientX: 0,
          clientY: 0,
          show: false,
        },
      });
  };

  networkCalls = {
    getReadRecentCustomerPortalErrors: {
      func: () => {
        this.setState({ loading: true }, () => {
          Axios.get('/api/v1/website/administration/read/all/recenterrors', {
            params: this.authData,
          })
            .then(result => this.setState({ errorList: result.data }))
            .catch(logOut)
            .finally(() => this.setState({ loading: false }));
        });
      },
      type: 'r',
    },
  };

  onContextMenu = (e, error) => {
    e?.preventDefault();
    let { clientX, clientY } = e;

    if (clientX + 300 > window.innerWidth) clientX = clientX - 280;

    this.setState({
      contextMenu: {
        clientX,
        clientY,
        show: true,
        error,
      },
      showDetail: false,
    });
  };

  viewDetails = () =>
    this.setState(p => ({
      showDetail: true,
      contextMenu: {
        ...p.contextMenu,
        clientX: 0,
        clientY: 0,
        show: false,
      },
    }));

  searchErrorOnGoogle = () => {
    const errorText = this.state.contextMenu.error.errorText.toString();
    const arr = errorText.match(/\s.+?:/);
    const url = `https://google.com/search?q=MySql ${arr[0]}`;
    this.setState(
      p => ({
        contextMenu: {
          ...p.contextMenu,
          clientX: 0,
          clientY: 0,
          show: false,
        },
      }),
      () => window.open(url, '_blank')
    );
  };

  render = () => (
    <div style={{ padding: '1vw' }}>
      <div className="row">
        <h5>Recent Customer Portal Errors</h5>
      </div>
      <div className="row">
        {this.state.loading ? (
          <div className="progress blue">
            <div className="indeterminate" />
          </div>
        ) : (
          <table className="highlight">
            <thead>
              <tr>
                <th style={{ padding: '2px' }}>User</th>
                <th style={{ padding: '2px' }}>Route</th>
                <th style={{ padding: '2px' }}>Time Stamp</th>
                <th style={{ padding: '2px' }}>Error</th>
              </tr>
            </thead>
            <tbody>
              {this.state.errorList?.map(e => (
                <tr
                  key={e.id}
                  className={
                    this.state.contextMenu?.error?.id === e.id
                      ? 'grey lighten-3'
                      : ''
                  }
                  style={{ cursor: 'default' }}
                  onContextMenu={err => this.onContextMenu(err, e)}
                >
                  <td style={{ padding: '2px' }}>
                    {e.firstName} {e.lastName}
                  </td>
                  <td style={{ padding: '2px' }}>{e.route}</td>
                  <td style={{ padding: '2px' }}>
                    {moment(e.timeStamp).format('MM/DD/YYYY hh:mm a')}
                  </td>
                  <td style={{ padding: '2px' }}>
                    {e.errorText.length > 120
                      ? `${e.errorText.substring(0, 120)}...`
                      : e.errorText}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      <div
        id="context-menu"
        className={this.state.contextMenu?.show ? '' : 'hide'}
        style={{
          zIndex: 100,
          position: 'fixed',
          top: this.state.contextMenu?.clientY,
          left: this.state.contextMenu?.clientX,
          border: '1px solid black',
          backgroundColor: 'white',
          boxShadow: '1px 1px 2px #ddd',
          borderRadius: '1px',
          padding: '8px',
          width: '280px',
          overflow: 'hidden',
        }}
      >
        <ul style={{ padding: '0px 80px 0px 12px', margin: '0px' }}>
          <li>
            <a
              href="/"
              className="black-text"
              style={{
                font: 'console',
                fontSize: '.8em',
                wordWrap: 'break-word',
              }}
              onClick={e => e.preventDefault()}
              onMouseDown={this.viewDetails}
            >
              View Details
            </a>
            <div style={{ height: '6px' }} />
            <div className="divider" />
            <div style={{ height: '6px' }} />
            <a
              href="/"
              className="black-text"
              style={{
                font: 'console',
                fontSize: '.8em',
                wordWrap: 'break-word',
              }}
              onClick={e => e.preventDefault()}
              onMouseDown={this.searchErrorOnGoogle}
            >
              Search Error on Google
            </a>
          </li>
        </ul>
      </div>
      <div
        id="log-entry-detail"
        className={this.state.showDetail ? '' : 'hide'}
        style={{
          zIndex: 100,
          position: 'fixed',
          top: '40px',
          right: '40px',
          border: '1px solid black',
          backgroundColor: 'white',
          boxShadow: '2px 2px 3px #ccc',
          borderRadius: '1px',
          padding: '8px',
          width: '33vw',
          minWidth: '300px',
          overflowX: 'hidden',
          overflowY: 'auto',
          maxHeight: '90vh',
        }}
      >
        <div className="row">
          <i
            className="material-icons col s1 offset-s11"
            style={{ cursor: 'pointer' }}
            onClick={() => this.setState({ showDetail: false })}
          >
            close
          </i>
        </div>
        <div className="row">
          <h5 className="center" style={{ textDecoration: 'underline' }}>
            Entry Details
          </h5>
        </div>
        {this.state.contextMenu?.error ? (
          <div className="row">
            <div className="col s4">
              <table>
                <tbody className="bolder">
                  <tr style={{ border: 'none' }}>
                    <td
                      style={{
                        padding: '2px',
                        textAlign: 'right',
                        marginRight: '12px',
                      }}
                    >
                      Error ID
                    </td>
                  </tr>
                  <tr style={{ border: 'none' }}>
                    <td
                      style={{
                        padding: '2px',
                        textAlign: 'right',
                        marginRight: '12px',
                      }}
                    >
                      User
                    </td>
                  </tr>
                  <tr style={{ border: 'none' }}>
                    <td
                      style={{
                        padding: '2px',
                        textAlign: 'right',
                        marginRight: '12px',
                      }}
                    >
                      Pharmacy
                    </td>
                  </tr>
                  <tr style={{ border: 'none' }}>
                    <td
                      style={{
                        padding: '2px',
                        textAlign: 'right',
                        marginRight: '12px',
                      }}
                    >
                      EmailAddress
                    </td>
                  </tr>
                  <tr style={{ border: 'none' }}>
                    <td
                      style={{
                        padding: '2px',
                        textAlign: 'right',
                        marginRight: '12px',
                      }}
                    >
                      Page Route
                    </td>
                  </tr>
                  <tr style={{ border: 'none' }}>
                    <td
                      style={{
                        padding: '2px',
                        textAlign: 'right',
                        marginRight: '12px',
                      }}
                    >
                      Time Stamp
                    </td>
                  </tr>
                  <tr style={{ border: 'none' }}>
                    <td
                      style={{
                        padding: '2px',
                        textAlign: 'right',
                        marginRight: '12px',
                      }}
                    >
                      Full Error Text
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="col s8">
              <table>
                <tbody>
                  <tr style={{ border: 'none' }}>
                    <td style={{ padding: '2px' }}>
                      {this.state.contextMenu.error.id}
                    </td>
                  </tr>
                  <tr style={{ border: 'none' }}>
                    <td style={{ padding: '2px' }}>
                      {this.state.contextMenu.error.firstName}{' '}
                      {this.state.contextMenu.error.lastName}
                    </td>
                  </tr>
                  <tr style={{ border: 'none' }}>
                    <td style={{ padding: '2px' }}>
                      {this.state.contextMenu.error.pharmacyId ? (
                        <Link
                          to={`/pharmacy/${this.state.contextMenu.error.pharmacyId}`}
                        >
                          {this.state.contextMenu.error.pharmacyName}
                        </Link>
                      ) : (
                        <span>&nbsp;</span>
                      )}
                    </td>
                  </tr>
                  <tr style={{ border: 'none' }}>
                    <td style={{ padding: '2px' }}>
                      {this.state.contextMenu.error.emailAddress ? (
                        <a
                          href={`mailto:${this.state.contextMenu.error.emailAddress}`}
                        >
                          {this.state.contextMenu.error.emailAddress}
                        </a>
                      ) : (
                        <span>&nbsp;</span>
                      )}
                    </td>
                  </tr>
                  <tr style={{ border: 'none' }}>
                    <td style={{ padding: '2px' }}>
                      {this.state.contextMenu.error.route ? (
                        <a
                          href={`https://reports.outdaterx.com${this.state.contextMenu.error.route}`}
                        >
                          {this.state.contextMenu.error.route}
                        </a>
                      ) : (
                        <span>&nbsp;</span>
                      )}
                    </td>
                  </tr>
                  <tr style={{ border: 'none' }}>
                    <td style={{ padding: '2px' }}>
                      {moment(this.state.contextMenu.error.timeStamp).format(
                        'MM/DD/YYYY hh:mm a'
                      )}
                    </td>
                  </tr>
                  <tr style={{ border: 'none' }}>
                    <td style={{ padding: '2px', wordWrap: 'break-word' }}>
                      {this.state.contextMenu.error.errorText}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default connect()(ErrorTab);
